// extracted by mini-css-extract-plugin
module.exports = {"first-view-body-wrapper":"styles_first-view-body-wrapper__1UDpx","first-view-body-text":"styles_first-view-body-text__3J3jE"};